import { queryOptions } from "@tanstack/react-query";
import { myAxios, myAxiosAdmin } from "../../utils/common";
import { IAdminMlPart, IAdminUnit, IAdminUnitMl } from "./adminTypes";
import { IAssignedModule, IAssignedTask, IModule, IPractice } from "../../types/generalTypes";
import { IUser } from "../../contexts/AuthContextProvider";

export const getAllUnits = async (): Promise<IAdminUnit[]> =>
  myAxiosAdmin.get("/admin/units").then((r) => r.data);

export const adminGetAllUnits = () =>
  queryOptions({
    queryFn: () => getAllUnits(),
    queryKey: ["adminAllUnits"],
  });

/*  */

export const getUnitsMls = async (unitId: number): Promise<IAdminUnitMl[]> =>
  myAxiosAdmin.get(`/admin/unit/${unitId}/mls`).then((r) => r.data);

export const adminGetUnitMls = ({
  unitId,
  enabled,
}: {
  unitId: number;
  enabled: boolean;
}) =>
  queryOptions({
    queryFn: () => getUnitsMls(unitId),
    queryKey: ["adminUnitMls", { unitId }],
    enabled,
  });

/*  */

export const getPartPractices = async (partId: number): Promise<IPractice[]> =>
  myAxiosAdmin.get(`/admin/part/${partId}/practices`).then((r) => r.data);

export const adminGePartPractices = ({ partId }: { partId: number }) =>
  queryOptions({
    queryFn: () => getPartPractices(partId),
    queryKey: ["adminPartPractices", { partId }],
  });

/*  */

export const getMlParts = async (mlId: number): Promise<IAdminMlPart[]> =>
  myAxiosAdmin.get(`/admin/ml/${mlId}/parts`).then((r) => r.data);

export const adminGetMlParts = ({
  mlId,
  enabled,
}: {
  mlId: number;
  enabled: boolean;
}) =>
  queryOptions({
    queryFn: () => getMlParts(mlId),
    queryKey: ["adminMlParts", { mlId }],
    enabled,
  });

/*  */

interface IFetchCohortModules {
  cohort_ids: number[];
}
export const fetchCohortModules = async (
  data: IFetchCohortModules
): Promise<IAssignedModule[]> =>
  myAxiosAdmin
    .post("/module_cohort_content/byCohortId", data)
    .then((r) => r.data);

export const adminCohortModules = (data: IFetchCohortModules) =>
  queryOptions({
    queryFn: () => fetchCohortModules(data),
    queryKey: ["cohortModules", data],
    enabled: data.cohort_ids && data.cohort_ids.length > 0,
  });

/*  */

interface IFetchCohortNotAssignedModules {
  cohort_ids: number[];
  topic: string;
}
export const fetchCohortNotAssignedModules = async (
  data: IFetchCohortNotAssignedModules
): Promise<IModule[]> =>
  myAxiosAdmin.post("/admin/modules/not-assigned/", data).then((r) => r.data);

export const adminCohortNotAssignedModules = (
  data: IFetchCohortNotAssignedModules
) =>
  queryOptions({
    queryFn: () => fetchCohortNotAssignedModules(data),
    queryKey: ["cohortNotAssignedModules", data],
    enabled: data.cohort_ids && data.cohort_ids.length > 0 && !!data.topic,
  });

/*  */

interface IFetchCohortAssignedModules {
  cohort_ids: number[];
}
export const fetchCohortAssignedModules = async (
  data: IFetchCohortAssignedModules
): Promise<IAssignedModule[]> =>
  myAxiosAdmin.post("/admin/modules/assigned/", data).then((r) => r.data);

export const adminCohortAssignedModules = (data: IFetchCohortAssignedModules) =>
  queryOptions({
    queryFn: () => fetchCohortAssignedModules(data),
    queryKey: ["cohortAssignedModules", data],
    enabled: data.cohort_ids && data.cohort_ids.length > 0,
  });

/*  */

export const fetchInstructors = async (): Promise<IUser[]> =>
  myAxiosAdmin.get("/admin/users/instructors/").then((r) => r.data);

export const adminGetInstructors = () =>
  queryOptions({
    queryFn: () => fetchInstructors(),
    queryKey: ["allInstructors"],
  });

/*  */

export const fetchModuleContentByMcId = async (
  mcId?: number
): Promise<IAssignedModule[]> => {
  return myAxios
    .post("/module_cohort_content/byMcId", {
      module_cohort_id: mcId,
    })
    .then((r) => r.data);
};

export const adminGetModuleContentByMcId = ({ mcId }: { mcId?: number }) =>
  queryOptions({
    queryFn: () => fetchModuleContentByMcId(mcId),
    queryKey: ["moduleContents", { mcId }],
    enabled: !!mcId,
  });

/*  */

export const fetchModuleContentByModuleId = async (
  moduleId?: number
): Promise<IAssignedTask[]> => {
  return myAxios.get("/module_content/" + moduleId).then((r) => r.data?.results);
};

/*  */

export const fetchModulesByTopic = async (topic: string): Promise<IModule[]> =>
  myAxiosAdmin
    // cohort_ids=[999999] → sahte cohort trick: atanmış modüller de dahil tümü gelir
    .post("/admin/modules/not-assigned/", { cohort_ids: [999999], topic })
    .then((r) => r.data);

export const adminGetModulesByTopic = (topic: string) =>
  queryOptions({
    queryFn: () => fetchModulesByTopic(topic),
    queryKey: ["modulesByTopic", topic],
    enabled: !!topic,
  });

export const adminGetModuleContentByModuleId = ({
  moduleId,
  enabled,
}: {
  moduleId?: number;
  enabled: boolean;
}) =>
  queryOptions({
    queryFn: () => fetchModuleContentByModuleId(moduleId),
    queryKey: ["contentsToAssign", { moduleId }],
    enabled,
  });

